class MobileMenu {
    constructor () {
        this.navToggle = document.querySelector(".nav-toggle");
        this.navMenu = document.querySelector(".nav-menu");
        this.subMenuBtn = document.querySelector(".submenu-btn");
        this.events();
    }

    events() {
        this.navToggle.addEventListener("click", () => this.openMenu());
        this.subMenuBtn.addEventListener("click", function(){
            let submenu = document.querySelector("#submenu")
            if(submenu.classList.contains('submenu')){
                submenu.classList.remove("submenu");
            }else{
                submenu.classList.add("submenu");
            }
            
        });
    }
    
    openMenu(){
        this.navMenu.classList.toggle("nav-menu_visible");
        if (this.navMenu.classList.contains("nav-menu_visible")) {
            this.navToggle.setAttribute("aria-label", "Cerrar menú");
        } else {
            this.navToggle.setAttribute("aria-label", "Abrir menú");
        }
    }
}

export default MobileMenu